import React, { useState, useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import "../styles/WhatsAppButton.css";

const WA_NUMBER = "351913987913";
const WA_MESSAGE = encodeURIComponent("Olá! Gostaria de saber mais sobre os vossos serviços.");

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Contactar pelo WhatsApp"
      className={`wa-btn ${visible ? "wa-btn--in" : ""}`}
    >
      <FaWhatsapp className="wa-btn__icon" />
    </a>
  );
}
